import PropTypes from 'prop-types'

import * as S from './styled'
function Spinner ({ ...rest }) {
  return (
    <S.Spinner viewBox="0 0 50 50">
      <S.Circle cx="25" cy="25" r="20" fill="none" strokeWidth="5" {...rest}/>
    </S.Spinner>
  )
}

Spinner.propTypes = {
  color: PropTypes.string
}

export default Spinner
